import { render, staticRenderFns } from "./AppSwitcher.vue?vue&type=template&id=6fc01ff0&scoped=true&"
import script from "./AppSwitcher.vue?vue&type=script&lang=ts&"
export * from "./AppSwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./AppSwitcher.vue?vue&type=style&index=0&id=6fc01ff0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc01ff0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
